module.exports = __webpack_public_path__ + "static/pm_module-2388bd4dea6b391d8a62b294f7a6dba7.jpg";